import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { WebhookDefinition } from "@app/models/rest/webhook-definition";

@Injectable({
  providedIn: "root"
})
export class WebhookDefinitionRestService extends HateoasResourceOperation<WebhookDefinition> {
  constructor() {
    super(WebhookDefinition);
  }
}
